
import { Component, Vue, Watch } from "vue-property-decorator";
import { roleService } from "@/api/settings/role";
import FormBase from "@/lib/view-base/formbase";
import { RoleDto, FlatPermissionDto } from "@/api/service-proxies";
import { TreeData } from "element-ui/types/tree";
import { Tree } from "element-ui";
import { setTimeout } from "timers";

@Component({
  name: "UpdateRole",
  components: {}
})
export default class UpdateRole extends FormBase {
  role: RoleDto = new RoleDto();
  permissions?: FlatPermissionDto[] | null = null;
  originPermissions: string[] = null;
  checkStrictly = true;

  rules: object = {
    name: [
      { required: true, message: "请输入角色名称", trigger: "blur" },
      { max: 16, message: "角色名称最大长度为16", trigger: "blur" }
    ],
    displayName: [
      { required: true, message: "请输入显示名称", trigger: "blur" },
      { max: 16, message: "显示名称最大长度为16", trigger: "blur" }
    ],
    description: [
      { max: 128, message: "Description最大长度为128", trigger: "blur" }
    ]
  };

  mounted() {
    this.getRole(+this.$route.params["id"]);
  }

  async getRole(id: number) {
    let role = await roleService.get(id);
    this.role = role;

    this.originPermissions = role.permissions;

    await this.getPermissions();

    setTimeout(() => {
      this.checkStrictly = false;
    }, 1000);
  }

  get computedPermission() {
    let data: TreeData[] = [];
    this.buildPermissionTree(null, data);

    return data;
  }

  buildPermissionTree(parentName: string | null, data: TreeData[]) {
    let permissions = this.permissions.filter(p => p.parentName == parentName);

    permissions.forEach(permission => {
      let node = {
        id: permission.name,
        label: permission.displayName,
        children: []
      };

      this.buildPermissionTree(permission.name, node.children);
      data.push(node);
    });
  }

  async getPermissions() {
    var result = await roleService.getAllPermissions();
    this.permissions = result.items;
  }

  async submitExecute(): Promise<void> {
    let permissions = (this.$refs.permissionTree as Tree)
      .getCheckedNodes(false, true)
      .map(item => item.id);

    this.role.permissions = permissions;

    await roleService.update(this.role);
  }
}
